import { createStore } from 'redux'

const initialState = {
  sidebarShow: 'responsive',
  vals:false
}

const changeState = (state = initialState,action) => {
  console.log(action);
   
  switch (action.type) {
    case 'setRes':
      return {...state, 
        sidebarShow : action.sidebarShow }

      case 'setLoading':
        return {...state,
          vals:action.vals
        }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store